import { useUserStoreWithOut } from '@/store/modules/user';
import { authPermission } from '@/utils/permission'
import { startPdfPreload } from '@/utils/pdfPreloader'

const LOGIN_PATH = '/login'
const BASE_PATH = '/home'
const whitePathList = [LOGIN_PATH]

// 需要PDF功能的页面路径
const pdfPages = ['/project', '/writing', '/template']

export default (router) => {
  const userStore = useUserStoreWithOut();

  router.beforeEach(async (to, from, next) => {
    const routes = router.getRoutes()
    let token = localStorage.getItem('token')

    if (to.query?.tid && to.query?.tid !== token) {
      userStore.setToken(to.query.tid)
      token = to.query.tid
    }
    
    if (whitePathList.includes(to.path)) {
      if (to.path === LOGIN_PATH && token) {
        try {
          await userStore.getUserInfoAction();
          next({ path: BASE_PATH, replace: true })
        } catch (error) {
          next()
        }
        return
      }
      next()
      return
    }

    if (!routes.find(v => v.path === to.path)) {
      next({ path: '/404', replace: true })
      return
    }

    if (!token) {
      next({ path: LOGIN_PATH, replace: true })
      return
    }

    if (!userStore.getUserInfo) {
      try {
        await userStore.getUserInfoAction();
      } catch (err) {
        next();
        return;
      }
    }

    if (to.meta.permissions && !authPermission(to.meta.permissions)) {
      next({ path: '/401', replace: true })
      return
    }

    // 如果访问需要PDF功能的页面，启动预加载
    if (pdfPages.some(page => to.path.startsWith(page))) {
      startPdfPreload()
    }

    next()
  })
}